import { render, staticRenderFns } from "./overrideTagName.vue?vue&type=template&id=4fb3705b&scoped=true&"
import script from "./overrideTagName.vue?vue&type=script&lang=js&"
export * from "./overrideTagName.vue?vue&type=script&lang=js&"
import style0 from "./overrideTagName.vue?vue&type=style&index=0&id=4fb3705b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb3705b",
  null
  
)

export default component.exports